import { useEffect } from 'react';

// Sets document.title per route. Without this, every route inherits
// index.html's static <title>, which means GA4's "Page title and screen
// class" dimension can't distinguish pages from each other -- confirmed via
// a live GA4 property showing 100% of a week's views under one title
// despite multiple routes clearly being visited (page_view/scroll/etc. all
// fired correctly; only the title never changed).
export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;
    return () => {
      document.title = previousTitle;
    };
  }, [title]);
};

export default useDocumentTitle;
